const PostSkeleton = () => {
    return (
        <article className="tease-post-container tease-post-skeleton">
            <div className="skeleton post-image skeleton-image"/>
            <div className="skeleton post-title skeleton-text big"/>
            <div className="post-content d-flex align-items-center justify-content-start">
                <div className="skeleton author-image skeleton-image"/>
                <div className="author-date d-flex flex-column big">
                    <div className="skeleton skeleton-text medium"/>
                    <div className="skeleton skeleton-text medium"/>
                </div>
            </div>
            <div className="skeleton post-button skeleton-text small"/>
        </article>
    )
}

export default PostSkeleton